"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ApiService.$inject = ['$http', '$q', 'config'];
function ApiService($http, $q, config) {
    var buildUrl = function (url) {
        return config.server.url + url;
    };
    this.get = function (url, params) {
        return $http({
            method: 'GET',
            url: buildUrl(url),
            params: params,
        }).then(function (response) {
            return response.data;
        });
    };
    this.post = function (url, data) {
        return $http({
            method: 'POST',
            url: buildUrl(url),
            data: data,
        }).then(function (response) {
            return response.data;
        });
    };
    this.update = function (url, data) {
        return $http({
            method: 'PATCH',
            url: buildUrl(url),
            data: data,
        }).then(function (response) {
            return response.data;
        });
    };
    this.remove = function (url) {
        return $http({
            method: 'DELETE',
            url: buildUrl(url)
        }).then(function (response) {
            return response.data;
        });
    };
    this.report = function (url, type, id, data) {
        return $http({
            method: 'POST',
            url: buildUrl(url) + '/' + type + '/' + id,
            data: data
        }).then(function (response) {
            return response.data;
        });
    };
}
ExternalApiService.$inject = ['$http', '$q', 'config'];
function ExternalApiService($http, $q, config) {
    var buildUrl = function (url) {
        return config.server.ext_url + url;
    };
    this.get = function (url, params) {
        return $http({
            method: 'GET',
            url: buildUrl(url),
            params: params,
        }).then(function (response) {
            return response.data;
        });
    };
    this.post = function (url, data) {
        return $http({
            method: 'POST',
            url: buildUrl(url),
            data: data,
        }).then(function (response) {
            return response.data;
        });
    };
    this.put = function (url, data) {
        return $http({
            method: 'PUT',
            url: buildUrl(url),
            data: data,
        }).then(function (response) {
            return response.data;
        });
    };
    this.update = function (url, data) {
        return $http({
            method: 'PATCH',
            url: buildUrl(url),
            data: data,
        }).then(function (response) {
            return response.data;
        });
    };
    this.remove = function (url) {
        return $http({
            method: 'DELETE',
            url: buildUrl(url)
        }).then(function (response) {
            return response.data;
        });
    };
    this.report = function (url, type, id, data) {
        return $http({
            method: 'POST',
            url: buildUrl(url) + '/' + type + '/' + id,
            data: data
        }).then(function (response) {
            return response.data;
        });
    };
    this.upload = function (url, file) {
        var fd = new FormData();
        fd.append('file', file);
        return $http.post(buildUrl(url), fd, {
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            }
        }).then(function (response) {
            return response.data;
        });
    };
    this.download = function (url) {
        return $http({
            method: 'GET',
            url: buildUrl(url),
            responseType: 'arraybuffer'
        }).then(function (response) {
            return response.data;
        });
    };
}
RequestService.$inject = ['$injector'];
function RequestService($injector) {
    /**
     * Request again using given config
     *
     * @param {Object} config
     * @returns {Promise}
     */
    this.resend = function (config) {
        return $injector.get('$http')(config);
    };
}
AuthService.$inject = ['storage', '$q', '$injector'];
function AuthService(storage, $q, $injector) {
    var service = {};
    var token = null;
    var defer = null;
    var AUTH_TOKEN = 'auth_token';
    service.expire = function () {
        service.setToken(null);
    };
    service.tokenExists = function () {
        return service.getToken() !== null;
    };
    service.getToken = function () {
        if (token === null) {
            token = storage.getItem(AUTH_TOKEN);
        }
        return token;
    };
    service.setToken = function (tkn) {
        if (tkn != null) {
            tkn = 'Bearer ' + tkn;
        }
        token = tkn;
        storage.setItem(AUTH_TOKEN, tkn);
    };
    service.getIdentity = function () {
        if (service.tokenExists()) {
            return $q.when(service.getToken);
        }
        else {
            if (!defer) {
                defer = $q.defer();
            }
            return defer.promise;
        }
    };
    service.resolveIdentity = function () {
        if (defer) {
            defer.resolve(service.getToken());
            defer = null;
        }
    };
    return service;
}
ApiExpiredInterceptor.$inject = ['$q', '$injector', 'auth'];
function ApiExpiredInterceptor($q, $injector, auth) {
    function handleAuthExpired(response) {
        auth.expire();
        return auth.getIdentity().then(function (token) {
            var $http = $injector.get('$http');
            $http.defaults.headers.common.Authorization = token;
            response.config.headers.Authorization = token;
            return $injector.get('request').resend(response.config);
        });
    }
    return {
        response: function (response) {
            if (response.status === 401) {
                return handleAuthExpired(response);
            }
            return response;
        },
        responseError: function (response) {
            if (response.status === 401) {
                return handleAuthExpired(response);
            }
            return $q.reject(response);
        },
    };
}
exports.default = angular.module('rinca.core.api', [])
    .service('api', ApiService)
    .service('extApi', ExternalApiService)
    .service('auth', AuthService)
    .service('apiExpiredInterceptor', ApiExpiredInterceptor)
    .service('request', RequestService)
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('apiExpiredInterceptor');
    }])
    .run(['auth', '$http', function (auth, $http) {
        if (auth.tokenExists()) {
            $http.defaults.headers.common.Authorization = auth.getToken();
        }
    }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/api.js
// module id = 292
// module chunks = 0